import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'
import { createIcon } from '../create-icon'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgColouredGoogle = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 14 14"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.72 7.15899C13.72 6.66263 13.6755 6.18535 13.5927 5.72717H7V8.4349H10.7673C10.605 9.3099 10.1118 10.0513 9.37045 10.5476V12.304H11.6327C12.9564 11.0854 13.72 9.29081 13.72 7.15899Z"
      fill="#4285F4"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99984 14C8.88984 14 10.4744 13.3731 11.6326 12.304L9.37029 10.5477C8.74348 10.9677 7.94166 11.2159 6.99984 11.2159C5.17666 11.2159 3.63348 9.9845 3.08302 8.32996H0.744385V10.1436C1.8962 12.4313 4.26348 14 6.99984 14Z"
      fill="#34A853"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.08318 8.33008C2.94318 7.91008 2.86364 7.46145 2.86364 7.00008C2.86364 6.53872 2.94318 6.09008 3.08318 5.67008V3.85645H0.744545C0.270454 4.80145 0 5.87054 0 7.00008C0 8.12963 0.270454 9.19872 0.744545 10.1437L3.08318 8.33008Z"
      fill="#FBBC05"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.99984 2.78409C8.02757 2.78409 8.95029 3.13727 9.67575 3.83091L11.6835 1.82318C10.4712 0.693636 8.88666 0 6.99984 0C4.26348 0 1.8962 1.56864 0.744385 3.85636L3.08302 5.67C3.63348 4.01545 5.17666 2.78409 6.99984 2.78409Z"
      fill="#EA4335"
    />
  </svg>
)
const ForwardRef = forwardRef(SvgColouredGoogle)
const IconSvgColouredGoogle = createIcon(ForwardRef, 'SvgColouredGoogle')
export default IconSvgColouredGoogle
